import gql from 'graphql-tag';

const GET_STOCK_BY_STORE_SKU = gql`
    query getStockByStoreAndSKU ($storeId: String!, $refIds: [String!]!) {
        getStockByStoreAndSKU (storeId: $storeId, refIds: $refIds) {
            status
            message
            data {
                matnr
                stock
            }
        }
    }
`;

export default GET_STOCK_BY_STORE_SKU;
